module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-container"
  }, [_c('section', [_c('el-col', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("projectManage.title")))])]), _vm._v(" "), _c('div', {
    staticClass: "addNew"
  }, [_c('div', {
    staticClass: "newBtn",
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("projectManage.create")))])])]), _vm._v(" "), _c('div', {
    staticClass: "project-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.projects,
      "empty-text": _vm.$t('common.noData'),
      "highlight-current-row": "",
      "min-width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('projectManage.name'),
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "apikey",
      "label": _vm.$t('projectManage.apikey'),
      "min-width": "32%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.apikey))]), _vm._v(" "), _c('p', {
          staticClass: "keyP"
        }, [_vm._v(_vm._s(scope.row.apikey))])]), _vm._v(" "), _c('div', {
          staticClass: "tag",
          on: {
            "click": function($event) {
              return _vm.copy('apikey', scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secret",
      "label": _vm.$t('projectManage.secret'),
      "min-width": "32%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(scope.row.secret))]), _vm._v(" "), _c('p', {
          staticClass: "keyP"
        }, [_vm._v(_vm._s(scope.row.secret))])]), _vm._v(" "), _c('div', {
          staticClass: "tag",
          on: {
            "click": function($event) {
              return _vm.copy('secret', scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('projectManage.operation'),
      "min-width": "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("projectManage.edit")))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("projectManage.delete")))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('projectManage.editWndTitle'),
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('projectManage.editWndName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.editSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('projectManage.createWndTitle'),
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('projectManage.createWndName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "EndpointBox"
  }, [_c('p', [_c('span', {
    staticClass: "EndpointTit"
  }, [_vm._v(_vm._s(_vm.$t("projectManage.endpoint")))]), _vm._v(" "), _c('el-select', {
    on: {
      "change": _vm.selectNetwork
    },
    model: {
      value: (_vm.network),
      callback: function($$v) {
        _vm.network = $$v
      },
      expression: "network"
    }
  }, _vm._l((_vm.networks), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "EndpointCon"
  }, [_vm._v(_vm._s(_vm.endpoint))])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09398f97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProjectManagement/ProjectManagement.vue
// module id = 972
// module chunks = 1